import React from 'react';

const CONTENT = {
  ro: {
    title: 'Termeni și Condiții',
    updated: 'Ultima actualizare: 20 februarie 2026',
    intro:
      'Prin accesarea și utilizarea ChessMindset.academy accepți acești termeni. Dacă nu ești de acord, te rugăm să nu folosești platforma.',
    sections: [
      {
        title: '1. Obiectul serviciului',
        body: 'ChessMindset.academy oferă conținut educațional de șah: lecții, puzzle-uri, progres și instrumente de învățare.'
      },
      {
        title: '2. Cont utilizator',
        body: 'Ești responsabil pentru datele contului și confidențialitatea parolei. Te obligi să furnizezi informații corecte și actualizate.'
      },
      {
        title: '3. Reguli de utilizare',
        body: 'Este interzisă utilizarea abuzivă a platformei, încercarea de acces neautorizat, copierea nepermisă a conținutului sau perturbarea serviciului.'
      },
      {
        title: '4. Proprietate intelectuală',
        body: 'Conținutul platformei (texte, design, materiale educaționale, fluxuri interactive) aparține ChessMindset.academy sau licențiatorilor și nu poate fi reutilizat fără acord.'
      },
      {
        title: '5. Progres, puncte și ranking',
        body: 'Sistemele de puncte, nivel, ranking, premii și badge-uri sunt mecanici educaționale interne și pot fi ajustate fără notificare prealabilă.'
      },
      {
        title: '6. Suspendare sau închidere cont',
        body: 'Ne rezervăm dreptul de a suspenda ori închide conturi care încalcă acești termeni, pentru protejarea comunității și securității platformei.'
      },
      {
        title: '7. Limitarea răspunderii',
        body: 'Serviciul este furnizat „ca atare”. Nu garantăm disponibilitate continuă fără întreruperi tehnice și nu răspundem pentru daune indirecte rezultate din utilizare.'
      },
      {
        title: '8. Modificarea termenilor',
        body: 'Putem actualiza acești termeni periodic. Versiunea actualizată publicată pe site intră în vigoare de la data afișării.'
      },
      {
        title: '9. Contact',
        body: 'Pentru întrebări legate de Termeni și Condiții: contact@chessmindset.academy.'
      }
    ]
  },
  en: {
    title: 'Terms & Conditions',
    updated: 'Last updated: February 20, 2026',
    intro:
      'By accessing and using ChessMindset.academy, you agree to these terms. If you do not agree, please do not use the platform.',
    sections: [
      {
        title: '1. Service scope',
        body: 'ChessMindset.academy provides chess educational content: lessons, puzzles, progress tracking, and learning tools.'
      },
      {
        title: '2. User account',
        body: 'You are responsible for your account credentials and password confidentiality. You agree to provide accurate and updated information.'
      },
      {
        title: '3. Usage rules',
        body: 'Abusive behavior, unauthorized access attempts, unauthorized content copying, or disruption of the service are prohibited.'
      },
      {
        title: '4. Intellectual property',
        body: 'Platform content (text, design, educational materials, interactive flows) belongs to ChessMindset.academy or its licensors and may not be reused without permission.'
      },
      {
        title: '5. Progress, points, and ranking',
        body: 'Points, levels, rankings, rewards, and badges are internal educational mechanics and may be adjusted without prior notice.'
      },
      {
        title: '6. Account suspension or closure',
        body: 'We reserve the right to suspend or close accounts that violate these terms to protect the community and platform security.'
      },
      {
        title: '7. Limitation of liability',
        body: 'The service is provided “as is”. We do not guarantee uninterrupted availability and are not liable for indirect damages resulting from use.'
      },
      {
        title: '8. Changes to terms',
        body: 'We may update these terms periodically. The updated version published on the site becomes effective from publication date.'
      },
      {
        title: '9. Contact',
        body: 'For Terms & Conditions questions: contact@chessmindset.academy.'
      }
    ]
  }
};

function TermsConditions({ language = 'ro', onBack }) {
  const c = CONTENT[language] || CONTENT.ro;

  return (
    <section className="privacy-page">
      <div className="privacy-card">
        <button type="button" className="privacy-back-btn" onClick={onBack}>
          {language === 'ro' ? '← Înapoi' : '← Back'}
        </button>
        <h1>{c.title}</h1>
        <p className="privacy-meta">{c.updated}</p>
        <p className="privacy-intro">{c.intro}</p>
        {c.sections.map((section) => (
          <article key={section.title} className="privacy-section">
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TermsConditions;
